import { useState } from 'react';

const SEEN_KEY = 'ttu-intro-seen';

/** Plays the short logo intro on a visitor's first ever visit; skipped for reduced-motion users. */
function shouldPlay() {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
  try {
    if (window.localStorage.getItem(SEEN_KEY)) return false;
    window.localStorage.setItem(SEEN_KEY, '1');
  } catch { /* storage unavailable: play it */ }
  return true;
}

export function SplashIntro() {
  const [visible, setVisible] = useState(shouldPlay);
  if (!visible) return null;
  return (
    <div
      className="intro-overlay"
      aria-hidden="true"
      onClick={() => setVisible(false)}
      onAnimationEnd={(event) => { if (event.animationName === 'intro-fade') setVisible(false); }}
    >
      <img src="/white-logo.png" alt="" className="intro-logo" />
    </div>
  );
}
